/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : App.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Routes,
    Navigate,
} from 'react-router-dom';

import {
    toolKit,
} from '@/components/core';

import {
    route_list,
} from '@/utils/router/core';

// Layouts
import GlobalLayout from '@/components/layouts/global/Layout';
import ErrorLayout from '@/components/layouts/error/Layout';
import MainLayout from '@/components/layouts/main/Layout';
import AuthLayout from '@/components/layouts/auth/Layout';
import DemoLayout from '@/components/layouts/demo/Layout';

// Pages
import PageNotFound from '@/pages/PageNotFound';
import Home from '@/pages/Home/Home';
import Account from '@/pages/Account';
import Auth from '@/pages/Auth';
import Legal from '@/pages/Legal/Legal';
import Privacy from '@/pages/Legal/Privacy';
import Cookies from '@/pages/Legal/Cookies';
import Contact from '@/pages/Legal/Contact';
import Demo from '@/pages/Demo/Home';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const layoutDict_error =
{
    layout: <ErrorLayout />,
    routes:
        [
            // TODO: Return Status Code 404 on server side
            {
                path: '*',
                element: <Navigate to={route_list.PAGE_NOT_FOUND} />
            },
            {
                path: route_list.PAGE_NOT_FOUND,
                element: <PageNotFound />,
            },
        ],
};

const layoutDict_main =
{
    layout: <MainLayout />,
    routes:
        [
            {
                index: true,
                element: <Home />,
            },
            {
                path: route_list.ACCOUNT,
                element: <Account />,
            },
            {
                path: route_list.LEGAL,
                element: <Legal />,
            },
            {
                path: route_list.PRIVACY,
                element: <Privacy />,
            },
            {
                path: route_list.COOKIES,
                element: <Cookies />,
            },
            {
                path: route_list.CONTACT,
                element: <Contact />,
            },
        ],
};

const layoutDict_authentication =
{
    layout: <AuthLayout />,
    routes:
        [
            {
                path: route_list.AUTH,
                element: <Navigate to={route_list.AUTH_SIGN_IN} />
            },
            {
                path: route_list.AUTH_SIGN_IN,
                element: <Auth />,
            },
            {
                path: route_list.AUTH_SIGN_UP,
                element: <Auth />,
            },
            {
                path: route_list.AUTH_RESET_PASSWORD,
                element: <Auth />,
            },
        ],
};

const layoutDict_demo =
{
    layout: <DemoLayout />,
    routes:
        [
            {
                path: route_list.DEMO,
                element: <Demo />,
            },
        ],
};

const layoutDict_global =
{
    layout: <GlobalLayout />,
    routes:
        [
            toolKit.api.routes.layoutBuilder(layoutDict_error),
            toolKit.api.routes.layoutBuilder(layoutDict_main),
            toolKit.api.routes.layoutBuilder(layoutDict_authentication),
            toolKit.api.routes.layoutBuilder(layoutDict_demo),
        ],
};



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function App() {
    return (
        <Fragment>
            <Routes>
                {/* Global layout */}
                {toolKit.api.routes.layoutBuilder(layoutDict_global, false)}
            </Routes>
        </Fragment>
    );
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default App;



// End of file
